import { useEffect, useState } from 'react';
import Select, { StylesConfig } from "react-select";
import ModalComponent from '../../../../core/common/modal/ModalComponent';
import './Document.css';
// import FolderStructure from './FolderStructure';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { constantsPermission } from '../../../../Config/Constants';
import { usePermission } from '../../../../core/hooks/PermissionHook';
import { useGetProjectFoldersQuery, useLazyGetPermissionsDocumentsQuery, useUpsertPermissionDocumentMutation } from '../../../../services/EndPointsApis';
import ListViewDocumentPermissions from './Permissions Document/ListViewDocumentPermissions';

const DocumentPermissions = ({ projectId, projectLookups }: any) => {
  //PermissionHook
  const { view: viewDocumentPermission, edit: editDocumentPermission, create: createDocumentPermission } = usePermission(constantsPermission?.moduleId?.documentPermission);

  const [activityTogglePopup, setActivityTogglePopup] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [showfilterModal, setShowfilterModal] = useState(false);
  const [showDocumentrModal, setShowDocumentModal] = useState(false);
  const [gridView, setGridView] = useState({
    value: 1, label: 'Tree View'
  });
  const [selectedRowId, setSelectedRowId] = useState<any[]>([]);
  const [selectedRoleId, setSelectedRoleId] = useState<any[]>([]);

  const [selectedFolderName, setSelectedFolderName] = useState('');

  const [imgePreview, setImagePreview] = useState('');

  const { data: folderStructureData, refetch } = useGetProjectFoldersQuery({ ProjectId: projectId })

  const [fileData, setFileData] = useState<File[]>([]);

  //Permissions Upsert
  const [permissions, { data: permissionsData, isError: isErrorPermissions, isSuccess: isSuccessPermissions, isLoading: isLoadingPermissions }] = useUpsertPermissionDocumentMutation()
  //api for document permissions
  // const { data: permissionData, refetch: refetchPermission } = useGetPermissionsDocumentsQuery({ ProjectId: projectId, RoleId: '1' })

  const [TriggerPermission, { data: permissionData }] = useLazyGetPermissionsDocumentsQuery()

  //Formik
  const initialValuesPermissions = {
    projectId: projectId,
    lst_Role: {
      id: 0,
      value: ""
    },
    folderPermissionList: [
      {
        associatedProjectId: projectId,
        children: [
          ""
        ],
        folderId: 0,
        entityName: "",
        parentId: 0,
        isCustom: true,
        entityPath: "",
        entitySize: 0,
        createdDate: "",
        isFile: true,
        isLocked: true,
      }
    ]
  }

  const formikPermissions = useFormik({
    initialValues: initialValuesPermissions,
    onSubmit: (values) => {
      const updatedValues = {
        ...values,
        folderPermissionList: values.folderPermissionList.map((item, index) =>
          index === 0 ? { ...item, entityPath: '' } : item
        ),
      };
      permissions(updatedValues);
    },

  });


  const handleSubmitPermissions = () => {
    formikPermissions.handleSubmit()
  }

  //Formik

  const handleClose = () => {
    setShowfilterModal(false)
  };

  // const handleSelect = (id: any) => {
  //   setSelectedRowId(id)
  // };


  const customStyles: StylesConfig = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "rgba(177, 31, 40, 1)" : "#fff",
      color: state.isFocused ? "#fff" : "#000",
      "&:hover": {
        backgroundColor: "rgba(177, 31, 40, 1)",
      },
    }),
  };


  const disable = selectedRowId.length > 1 || selectedRowId.length === 0;


  useEffect(() => {
    if (permissionData?.result) {
      formikPermissions.setValues(permissionData?.result);
    }
  }, [permissionData])

  // useEffect(() => {
  //   refetchPermission()
  // }, [refetch])

  useEffect(() => {
    TriggerPermission({ ProjectId: projectId, RoleId: '1' })
  }, [])


  useEffect(() => {
    if (isSuccessPermissions) {
      toast.success("Permission Granted successfully");
      TriggerPermission({ ProjectId: projectId, RoleId: selectedRoleId })
    }
  }, [isSuccessPermissions])


  return (
    <>
      <ModalComponent
        modalTitle='Saving Current Filters'
        isVisible={showfilterModal}
        cancelButton="Cancel"
        onClose={handleClose}
        saveButton='Save'
        className="p-2"
      >
        <>
          <div className="col-md-12">
            <label className="col-form-label">
              Filter Name<span className="text-danger"> *</span>
            </label>
            <input type="text" className="form-control" />
          </div>
        </>
      </ModalComponent>
      <div>
        <div className='row'>
          <div className='col-md-12'>
            <div className="card main-card">
              <div className="card-body">
                {/* Search */}
                <div className="row">
                  <div className='d-flex justify-content-end'>
                    <div className="col-md-12 col-sm-12">
                      <div className='d-flex justify-content-end gap-3'>
                        <div className='d-flex align-items-center gap-3'><p className='mb-0'>Select Roles:</p>   <Select
                          styles={customStyles}
                          className="select custom-select-document "
                          options={projectLookups?.result?.Roles?.map((option: any) => ({
                            label: option?.value,
                            value: option?.id
                          }))}
                          value={
                            formikPermissions.values?.lst_Role?.id
                              ? {
                                value: formikPermissions.values?.lst_Role?.id,
                                label: formikPermissions.values?.lst_Role?.value || '',
                              }
                              : null
                          }
                          onChange={(selectedOption: any) => {
                            formikPermissions.setFieldValue('lst_Role.id', selectedOption.value);
                            formikPermissions.setFieldValue('lst_Role.value', selectedOption.label);
                            setSelectedRoleId(selectedOption.value)
                            TriggerPermission({ ProjectId: projectId, RoleId: selectedOption.value })
                          }}
                        /></div>
                        {createDocumentPermission &&
                          <button className="btn btn-primary px-3" onClick={handleSubmitPermissions} disabled={disable}> Lock </button>
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <ListViewDocumentPermissions formikPermissions={formikPermissions} projectId={projectId} setSelectedRowId={setSelectedRowId} setSelectedFolderName={setSelectedFolderName} />
                </div>
              </div>
            </div>
          </div>
        </div >

      </div>



    </>
  )
}

export default DocumentPermissions
